/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import { combineReducers } from 'redux';
import cards from './Cards/cards.reducer';
import news from './News/news.reducer';
import bookmakers from './Bookmakers/bookmakers.reducer';
import panelTemplate from './BookmakerRegPanel/panelTemplate.reducer';
import advertisement from './Advertisement/advertisement.reducer';
import { getNewsTitle, isContentHubPage } from './utils/contentHubHelper';

/**
 * Root reducer of application
 * It combines:
 * - Cards reducer (optional)
 * - News reducer
 * - Bookmakers reducer
 * - Advertisement reducer
 * - Content Hub reducer
 */
export const getReducers = () => {
    const reducers = {
        news,
        bookmakers,
        panelTemplate,
        advertisement,
        newsTitle: getNewsTitle,
    };

    /**
     * Cards section absent at Content Hub pages
     */
    if (!isContentHubPage()) {
        reducers.cards = cards;
    }

    return reducers;
};

export default combineReducers(getReducers());




// WEBPACK FOOTER //
// ./src/js/rootReducer.js